// extracted by mini-css-extract-plugin
export default {"selectAddress":"styles_selectAddress__ng-ot","input":"styles_input__aov2A","modal":"styles_modal__g7pxR"};